import { Link, Head } from '@inertiajs/react';
import { PageProps } from '@/types';
import { Icon } from '@iconify/react';
import Header from '@/Layouts/Partials/Header';
import Footer from '@/Layouts/Partials/Footer';
import { SettingModel } from '@/types/models/setting';
import FrontLayout from '@/Layouts/FrontLayout';
import { useEffect, useState } from 'react';
import HeroSlider from '@/Components/Homepage/HeroSlider';
import SliderWithDescription from '@/Components/Homepage/SliderWithDescription';
import ChoiceOnMedal from '@/Components/Homepage/ChoiceOnMedal';
import LandscapeWithBox from '@/Components/Homepage/LandscapeWithBox';
import IconsWithTexts from '@/Components/Homepage/IconsWithTexts';
import InvestmentOnMedal from '@/Components/Homepage/InvestmentOnMedal';
import FindApartment from '@/Components/Homepage/FindApartment';
import Facilities from '@/Components/Homepage/Facilities';
import ApartmentSearch from '@/Components/Homepage/ApartmentSearch';
import { SearchEngineData } from '@/types/searchEngineData';
import { GalleryModel } from '@/types/models/gallery';
import GallerySlider from '@/Components/Homepage/GallerySlider';
import News from '@/Components/Homepage/News';
import { PostModel } from '@/types/models/post';
import AboutInvestor from '@/Components/Homepage/AboutInvestor';
import ContactForm from '@/Components/Universal/ContactForm';
import { GalleryCategory } from '@/types/models/galleryCategory';
import TopHero from '@/Components/Universal/TopHero';
import CategoriesLoop from '@/Components/Gallery/CategoriesLoop';
import Container from '@/Components/Grid/Container';
import Row from '@/Components/Grid/Row';
import Column from '@/Components/Grid/Column';

export default function Gallery({ posts }: PageProps<{
    posts: PostModel[]
}>) {
    const getFormat = (filename: string) => {
        return filename.split('.').pop() as string;
    };

    return (
        <>
            <Head title="Osiedle Kusocińskiego">
                <meta name='description' content='Osiedle Kusocińskiego'/>
            </Head>
            <FrontLayout>
                <TopHero image='general-breadcrumbs-bg.webp' text='Aktualności' />
                <Container className='mt-20 mb-10'>
                    <Row>
                        <Column>
                            {posts && posts.map((item, i) => (
                                <Row className='mb-12' key={i}>
                                    <Column xl={6} lg={6} md={6}>
                                        <picture>
                                            <source
                                                srcSet={`${item.photo.replace(/\.[^.]+$/, '')}.webp`}
                                                type="image/webp"
                                            />
                                            <source
                                                srcSet={`${item.photo.replace(/\.[^.]+$/, '')}.${getFormat(item.photo)}`}
                                                type={`image/${getFormat(item.photo)}`}
                                            />
                                            <img className={`w-full max-h-[420px] maxMd:object-contain maxMd:mb-6 object-cover object-center`} src={item.photo} alt={item.name + i} />
                                        </picture>
                                    </Column>
                                    <Column xl={6} lg={6} md={6}>
                                        <div className="pl-8 maxMd:pl-0">
                                            <p className='uppercase text-label leading-label mb-2 text-secondary font-extrabold'>Data dodania: {item.created_at}</p>
                                            <h2 className='text-h3 leading-h3 text-primary font-extrabold mb-8 maxMd:mb-6'>{item.name}</h2>
                                            <div className='text-p text-text leading-p mb-6' dangerouslySetInnerHTML={{ __html: item.excerpt }}></div>
                                            <Link href={route('frontend.news.single', { post: item.slug })} className='button-outline max-w-[200px]'>
                                                Czytaj dalej
                                                <Icon icon="formkit:arrowright" width={24} className="ml-1" />
                                            </Link>
                                        </div>
                                    </Column>
                                </Row>
                            ))}
                        </Column>
                    </Row>
                </Container>
                <ContactForm smallerMargin />
            </FrontLayout>
        </>
    );
}
